import script from "./DateSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateSelect.vue?vue&type=script&lang=ts&setup=true"

import "./DateSelect.vue?vue&type=style&index=0&id=c8b8cfa6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b8cfa6"]])

export default __exports__